import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from "react";
import { injectStyle, resizeOpposite } from "../util/index.js";
/**
 * Resize button with resizer (three vertical dots) and collapse button.
 *
 * @returns
 */ export class ResizeButton extends Component {
    static{
        this.stateKeys = "defaultRestoreWidth,restoreWidth".split(",");
    }
    constructor(props){
        super(props), this.currentlyResizing = false, this.handleDoubleClick = ()=>{
            const width = this._getContainerWidth() > 0 ? 0 : this.state.restoreWidth;
            this.handleResize(width, null);
            this.props.onResizeFinished && this.props.onResizeFinished(width);
        }, this.handleMouseDown = (ev)=>{
            ev.preventDefault();
            document.addEventListener("pointermove", this.handleResize);
            this.currentlyResizing = true;
        }, this.handleMouseUp = (ev)=>{
            document.removeEventListener("pointermove", this.handleResize);
            this.currentlyResizing && this.props.onResizeFinished && this.props.onResizeFinished(this._getContainerWidth());
            this.currentlyResizing = false;
        }, this.handleOpposite = (width)=>{
            if (this.props.onResizeOpposite) {
                return this.props.onResizeOpposite(this._container.id, this.props.opposite.id, width, injectStyle);
            } else {
                return resizeOpposite(this._container.id, this.props.opposite.id, width);
            }
        }, this.handleResize = (ev, force)=>{
            const { minWidth, maxWidth } = this.props;
            const isEvent = !!(ev && ev.pageX);
            let x = isEvent ? ev.pageX - (this._container.getBoundingClientRect().left + document.body.scrollLeft) - 15 : ev; // Offset
            let move = x >= minWidth && x <= maxWidth;
            // Prevent default if event
            isEvent && ev.preventDefault();
            // Allow collapse
            x < minWidth - 50 && (move = x = 1);
            const collapse = move === 1;
            const xOpposite = x + this.props.oppositeOffset;
            window.requestAnimationFrame(()=>{
                if ((move || force) && this.handleOpposite(collapse ? x : xOpposite) !== false) {
                    this._container.style.width = `${xOpposite}px`;
                    !collapse && this.setState({
                        restoreWidth: x
                    });
                    this.props.onResize && this.props.onResize(x, collapse);
                }
            });
        };
        const { initialWidth, minWidth, restoreWidth } = props;
        const defaultRestoreWidth = typeof initialWidth === "number" ? initialWidth : minWidth;
        this.state = {
            defaultRestoreWidth,
            restoreWidth: restoreWidth || defaultRestoreWidth
        };
    }
    /**
     * Avoid rerender of the resizebutton during resizing.
     */ shouldComponentUpdate(nextProps, nextState) {
        const changedState = ResizeButton.stateKeys.filter((k)=>this.state[k] !== nextState[k]);
        if (changedState.length === 1 && changedState[0] === "restoreWidth") {
            return false;
        }
        return true;
    }
    componentDidMount() {
        // Add handler to the resize button
        this._getContainer(".aiot-split-resizer").addEventListener("pointerdown", this.handleMouseDown);
        document.addEventListener("pointerup", this.handleMouseUp);
        // Initialize resize width
        const { defaultRestoreWidth } = this.state;
        this.handleResize(defaultRestoreWidth, null);
        this.props.onResizeFinished && this.props.onResizeFinished(defaultRestoreWidth);
    }
    render() {
        return /*#__PURE__*/ _jsxs("span", {
            className: "aiot-split",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "aiot-split-resizer"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "aiot-split-collapse",
                    onClick: this.handleDoubleClick
                })
            ]
        });
    }
    _getContainer(find, singleFind = true) {
        const elem = document.getElementById(this.props.containerId);
        const findObj = find ? elem && elem.querySelectorAll(find) : elem;
        this._container = elem;
        if (find && singleFind) {
            return findObj && findObj[0];
        }
        return findObj;
    }
    _getContainerWidth() {
        const computed = window.getComputedStyle(this._container);
        const width = parseInt(computed.width, 10);
        return width - parseInt(computed.borderLeftWidth, 10) - parseInt(computed.borderRightWidth, 10);
    }
}
